import React,{ useEffect, useContext } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import {language} from 'config';
import { FirebaseContext } from 'common';

function AuthLoading(props) {
    const { api } = useContext(FirebaseContext);
    const {
        fetchUser,
        fetchSettings, 
        fetchBookings,
        fetchCancelReasons,
        fetchUsers,
        fetchNotifications,
        signOut,
        fetchAllLocations,
    } = api;
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);

    useEffect(()=>{
        dispatch(fetchUser());
        dispatch(fetchSettings());
        dispatch(fetchAllLocations());
    },[dispatch,fetchUser,fetchSettings,fetchAllLocations]);

    useEffect(()=>{
        if(auth.info){
            if(auth.info.profile){
                let role = auth.info.profile.usertype;
                if(role === 'rider'){
                    dispatch(fetchBookings(auth.info.uid,role));       
                    dispatch(fetchCancelReasons());
                }
                else if(role === 'admin'){
                    dispatch(fetchUsers());
                    dispatch(fetchBookings(auth.info.uid,role));
                    dispatch(fetchNotifications());
                    dispatch(fetchCancelReasons());
                }
                else{
                    alert(language.not_valid_user_type);
                    dispatch(signOut());
                }
            }else{
                alert(language.user_issue_contact_admin);
                dispatch(signOut());
            }
        }
    },[auth.info,dispatch,fetchBookings,fetchCancelReasons,fetchNotifications,fetchUsers,signOut]);

    return (
        auth.loading? <CircularLoading/>:props.children
    )
}

export default AuthLoading;